/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { StarredObjectType } from "./StarredObjectType";
import {
  StarredObjectTypeFromJSON,
  StarredObjectTypeFromJSONTyped,
  StarredObjectTypeToJSON,
  StarredObjectTypeToJSONTyped,
} from "./StarredObjectType";

/**
 *
 * @export
 * @interface StarredObjects
 */
export interface StarredObjects {
  /**
   *
   * @type {string}
   * @memberof StarredObjects
   */
  starredObjectId?: string;
  /**
   *
   * @type {string}
   * @memberof StarredObjects
   */
  userEmail?: string;
  /**
   *
   * @type {string}
   * @memberof StarredObjects
   */
  objectId?: string;
  /**
   *
   * @type {StarredObjectType}
   * @memberof StarredObjects
   */
  objectType?: StarredObjectType;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof StarredObjects
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof StarredObjects
   */
  reason?: string;
}

/**
 * Check if a given object implements the StarredObjects interface.
 */
export function instanceOfStarredObjects(
  value: object,
): value is StarredObjects {
  return true;
}

export function StarredObjectsFromJSON(json: any): StarredObjects {
  return StarredObjectsFromJSONTyped(json, false);
}

export function StarredObjectsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StarredObjects {
  if (json == null) {
    return json;
  }
  return {
    starredObjectId:
      json["starredObjectId"] == null ? undefined : json["starredObjectId"],
    userEmail: json["userEmail"] == null ? undefined : json["userEmail"],
    objectId: json["objectId"] == null ? undefined : json["objectId"],
    objectType:
      json["objectType"] == null
        ? undefined
        : StarredObjectTypeFromJSON(json["objectType"]),
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    reason: json["reason"] == null ? undefined : json["reason"],
  };
}

export function StarredObjectsToJSON(json: any): StarredObjects {
  return StarredObjectsToJSONTyped(json, false);
}

export function StarredObjectsToJSONTyped(
  value?: StarredObjects | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    starredObjectId: value["starredObjectId"],
    userEmail: value["userEmail"],
    objectId: value["objectId"],
    objectType: StarredObjectTypeToJSON(value["objectType"]),
    createdAt: value["createdAt"],
    reason: value["reason"],
  };
}
